import { officeTypeService } from '@/services/api/officeType.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { officeTypeModel } from '@/models/api/officeType.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const OFFICE_TYPE_MODULE = "api/officeType";

// ACTIONS
export const GET_ALL_OFFICE_TYPE = 'getAllOfficeType';
export const CREATE_OFFICE_TYPE = 'createOfficeType';
export const GET_OFFICE_TYPE = 'getOfficeType';
export const UPDATE_OFFICE_TYPE = 'updateOfficeType';
export const UPDATE_OFFICE_TYPE_STATUS = 'updateOfficeTypeStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_OFFICE_TYPE_SUCCESS = "allOfficeTypeSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_OFFICE_TYPE_SUCCESS = "getOfficeTypeSuccess";

export const actions = {
    [GET_ALL_OFFICE_TYPE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        officeTypeService
            .getAll(filter)
            .then((result) => {
                commit(ALL_OFFICE_TYPE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_OFFICE_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return officeTypeService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_OFFICE_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_OFFICE_TYPE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return officeTypeService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_OFFICE_TYPE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_OFFICE_TYPE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return officeTypeService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_OFFICE_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_OFFICE_TYPE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return officeTypeService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_OFFICE_TYPE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_OFFICE_TYPE_SUCCESS](state, {data}) {
        let officeType = data.data || [];
        state.list.data = officeType;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = officeType.map(item => officeTypeModel(item));
        }
    },
    [GET_OFFICE_TYPE_SUCCESS](state, data) {
        state.details = officeTypeModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
